var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"elLoadMore",staticClass:"rb-load-more",staticStyle:{"background-color":"#fff","width":"30px","height":"30px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }